import { render, staticRenderFns } from "./stopped-list-item.component.vue?vue&type=template&id=1299754e&scoped=true"
import script from "./stopped-list-item.component.vue?vue&type=script&lang=js"
export * from "./stopped-list-item.component.vue?vue&type=script&lang=js"
import style0 from "./stopped-list-item.component.vue?vue&type=style&index=0&id=1299754e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1299754e",
  null
  
)

export default component.exports